import ApolloClient from 'apollo-boost';
import fetch from 'cross-fetch';
import { gql_url } from '../../config';

const client = new ApolloClient({
  uri: gql_url,
  fetchOptions: {
    // Additional fetch options like `credentials` or `headers`
    credentials: 'include',
  },
  fetch,
  // queryDeduplication: true,
});

export default function createApolloClient() {
  return client;
}

export const query = function(query, variables, options) {
  return client.query({
    query,
    variables,
    ...options,
  });
};
export const mutate = function(mutation, variables) {
  return client.mutate({
    mutation,
    variables,
  });
};

export async function restFetcher(method, url, body) {
  // console.log('Rest Fetching');
  let resp = await fetch(url, {
    method: method || 'GET',
    credentials: 'include',
    body: (body && JSON.stringify(body)) || null,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then(async res => {
      // console.log('Successfully queried');
      return res.json();
    })
    .catch(err => {
      console.log('Error querrying', method, url, body, err);
    });
  // console.log('Rest Fetching - Done');
  return resp;
}



// WEBPACK FOOTER //
// ./src/core/createApolloClient/createApolloClient.client.js